import { ReactNode } from 'react';
import logoIcone from '../assets/logo.png';

interface KpiProps {
  titulo: string;
  valor: string;
  detalhe?: string;
  tone?: 'primaria' | 'sucesso' | 'erro' | 'dourado';
  icone?: ReactNode;
}

const TONS: Record<NonNullable<KpiProps['tone']>, { cor: string; fundo: string }> = {
  primaria: { cor: '#1845ba', fundo: 'rgba(24, 69, 186, 0.12)' },
  sucesso: { cor: '#1e9e58', fundo: 'rgba(30, 158, 88, 0.12)' },
  erro: { cor: '#e0293e', fundo: 'rgba(224, 41, 62, 0.12)' },
  dourado: { cor: '#f2a900', fundo: 'rgba(242, 169, 0, 0.14)' },
};

export function Kpi({ titulo, valor, detalhe, tone = 'primaria', icone }: KpiProps) {
  const cores = TONS[tone];

  return (
    <div
      className="cartao-com-hover"
      style={{
        background: 'var(--cor-branco)',
        borderRadius: 'var(--raio-padrao)',
        boxShadow: 'var(--sombra-padrao)',
        border: '1px solid var(--cor-borda)',
        padding: '18px',
        display: 'flex',
        gap: '14px',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '12px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: icone ? cores.fundo : 'transparent',
          overflow: 'hidden',
        }}
      >
        {icone ? (
          <span style={{ color: cores.cor, fontSize: '20px', display: 'flex' }}>{icone}</span>
        ) : (
          <img src={logoIcone} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: '13px', margin: 0, opacity: 0.7 }}>{titulo}</p>
        <strong style={{ fontSize: '21px', color: cores.cor, display: 'block', marginTop: '2px', lineHeight: 1.2 }}>{valor}</strong>
        {detalhe && <p style={{ fontSize: '12px', margin: '3px 0 0', opacity: 0.6 }}>{detalhe}</p>}
      </div>
    </div>
  );
}
